import BaseRegistration from "./components/connexion/BaseRegistration.vue";
import Login from "./components/connexion/Login.vue";
import EditorAnswer from './components/ticket/EditorAnswer.vue';
import FilmInfo from './components/ticket/FilmInfo.vue';
import Multilingual from "./components/Multilingual.vue";
import NavbarNotification from './components/navbar/NavbarNotification.vue';
import SelectLocale from "./components/navbar/SelectLocale.vue";
import SearchTable from "./components/SearchTable.vue";
import Requests from "./views/requests/Requests.vue";
import WorkflowsSchemaTable from "./views/admin/workflow/WorkflowsSchemaTable.vue";
import WorkflowSchemaEdit from "./views/admin/workflow/WorkflowSchemaEdit.vue";
import CustomerTicketsTable from "./views/ticket/CustomerTicketsTable.vue";
import AdminCustomerCreate from "./views/admin/customer/AdminCustomerCreate.vue";
import AdminCustomerEdit from "./views/admin/customer/AdminCustomerEdit.vue";
import AdminTicketsTable from "./views/admin/ticket/AdminTicketsTable.vue";
import AdminTicketShow from "./views/admin/ticket/AdminTicketShow.vue";
import CustomerTicketShow from "./views/ticket/CustomerTicketShow.vue";
import ProjectsTable from "./views/admin/project/ProjectsTable.vue";
import ProjectEdit from "./views/admin/project/ProjectEdit.vue";
import UserSetterContainer from "./views/admin/user/UserSetterContainer.vue";
import UsersTable from "./views/admin/user/UsersTable.vue";
import UserEdit from "./views/admin/user/UserEdit.vue";
import UserCreate from "./views/admin/user/UserCreate.vue";
import RightsRoleSetterContainer from "./views/admin/role/RightsRoleSetterContainer.vue";
import RolesTable from "./views/admin/role/RolesTable.vue";
import GroupTable from "./views/admin/group/GroupTable.vue";
import GroupEdit from "./views/admin/group/GroupEdit.vue";
import CustomerProfile from "./components/customer/Profile.vue";
import CustomerRegistration from "./components/customer/CustomerRegistration.vue";
import BillingDetails from "./components/BillingDetails.vue";
import ShippingDetails from "./components/ShippingDetails.vue";
import RequestFormList from "./views/requests/FormList.vue";
import CustomersTable from "./components/admin/CustomersTable.vue";
import AdminLogin from "./components/admin/Login.vue";
import FormShow from './views/requests/FormShow.vue';
import Vue from "vue";
import WarningComponent from "./components/WarningComponent.vue";
import CustomRichTextEditor from './components/ticket/CustomRichTextEditor.vue';
/**
 * Register components for blade template and base UI items
 */
export default function registerComponents() {
    Vue.component('warning-component', WarningComponent);
    // Note: you could store in new Vue({components: {...}). But then, you lose the ability to ctrl-click into the
    // component from a blade template file. It's not worth it. We keep this very verbose declaration.
    Vue.component('navbar-notification', NavbarNotification);
    Vue.component('editor-answer', EditorAnswer);
    Vue.component('film-info', FilmInfo);
    Vue.component('search-table', SearchTable);
    Vue.component('customer-tickets-table', CustomerTicketsTable);
    Vue.component('admin-tickets-table', AdminTicketsTable);
    Vue.component('customer-ticket-show', CustomerTicketShow);
    Vue.component('rights-role-setter-container', RightsRoleSetterContainer);
    Vue.component('roles-table', RolesTable);
    Vue.component('users-table', UsersTable);
    Vue.component('user-setter-container', UserSetterContainer);
    Vue.component('user-edit', UserEdit);
    Vue.component('user-create', UserCreate);
    Vue.component('workflows-schema-table', WorkflowsSchemaTable);
    Vue.component('workflow-schema-edit', WorkflowSchemaEdit);
    Vue.component('group-table', GroupTable);
    Vue.component('group-edit', GroupEdit);
    Vue.component('projects-table', ProjectsTable);
    Vue.component('project-edit', ProjectEdit);
    Vue.component('admin-customers-table', CustomersTable);
    Vue.component('admin-customers-edit', AdminCustomerEdit);
    Vue.component('admin-customers-create', AdminCustomerCreate);
    Vue.component('select-locale', SelectLocale);
    Vue.component('multilingual', Multilingual);
    Vue.component('login', Login);
    Vue.component('base-registration', BaseRegistration);
    Vue.component('requests', Requests);
    Vue.component('form-list', RequestFormList);
    Vue.component('customer-profile', CustomerProfile);
    Vue.component('customer-registration', CustomerRegistration);
    Vue.component('billing-details', BillingDetails);
    Vue.component('shipping-details', ShippingDetails);
    Vue.component('admin-login', AdminLogin);
    Vue.component('admin-ticket-show', AdminTicketShow);
    Vue.component('form-show', FormShow);
    Vue.component('custom-rich-text-editor', CustomRichTextEditor);
}
